module.exports = __webpack_public_path__ + "static/media/service_sp.f61b1ac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/service_sp.jpg
// module id = 491
// module chunks = 0